import React from 'react';

interface RepresentationProps {
  agentEmail?: string;
  agentPhone?: string;
  agentName?: string;
  agentLicenseNumber?: string;
  agentCompanyName?: string;
  agentCompanyLicense?: string;
  agentCompanyStateLicense?: string;
  agentCompanyAddress?: string;
  agentAddress?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
  };
}

const Representation = ({
  agentEmail,
  agentPhone,
  agentName,
  agentLicenseNumber,
  agentCompanyName,
  agentCompanyLicense,
  agentCompanyStateLicense,
  agentCompanyAddress,
  agentAddress,
}: RepresentationProps) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Representation
      </h2>

      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          All representations, claims, advertising, promotional activities,
          brochures or plans of any kind made by Seller, Brokers, Unbeatable
          Loans LLC, their licensees, employees, officers or partners are not a
          part of this Agreement unless expressly incorporated or stated in this
          Agreement. This Agreement contains the whole agreement between Seller
          and Buyer, and there are no other terms, obligations, covenants,
          representations, statements or conditions, oral or otherwise, of any
          kind whatsoever concerning this sale. This Agreement will not be
          altered, amended, changed or modified except in writing executed by
          the parties.
        </li>
        <li>
          Unless otherwise stated in this Agreement, Buyer has inspected the
          Property (including fixtures and any personal property specifically
          listed herein) before signing this Agreement or has waived the right
          to do so, and agrees to purchase the Property in its present
          condition, subject to inspection contingencies elected in this
          Agreement. Buyer acknowledges that Brokers, their licensees,
          employees, officers or partners have not made an independent
          examination or determination of the structural soundness of the
          Property, the age or condition of the components, environmental
          conditions, the permitted uses, nor of conditions existing in the
          locale where the Property is situated; nor have they made a mechanical
          inspection of any of the systems contained therein.
        </li>
        <li>
          Any repairs required by this Agreement will be completed in a
          workmanlike manner.
        </li>
        <li>
          Broker(s) have provided or may provide services to assist
          unrepresented parties in complying with this Agreement.
        </li>
      </ol>

      {/* Agent Contact Information */}
      {(agentEmail || agentPhone || agentAddress) && (
        <div className="mt-6 bg-gray-50 p-4 rounded">
          <h3
            className="text-lg font-bold mb-4"
            style={{ fontSize: '14pt', fontWeight: 'bold' }}
          >
            LISTING AGENT/BROKER CONTACT AND LICENSE INFORMATION
          </h3>
          <div className="space-y-2">
            <p>
              <strong>Agent Name:</strong>{' '}
              <span className="font-semibold">{agentName || 'N/A'}</span>
            </p>
            <p>
              <strong>Email Address:</strong>{' '}
              <span className="font-semibold">{agentEmail || 'N/A'}</span>
            </p>
            <p>
              <strong>Phone Number:</strong>{' '}
              <span className="font-semibold">{agentPhone || 'N/A'}</span>
            </p>
            <p>
              <strong>License Number:</strong>{' '}
              <span className="font-semibold">
                {agentLicenseNumber || 'N/A'}
              </span>
            </p>
            <p>
              <strong>Company Name:</strong>{' '}
              <span className="font-semibold">{agentCompanyName || 'N/A'}</span>
            </p>
            <p>
              <strong>Company License:</strong>{' '}
              <span className="font-semibold">
                {agentCompanyLicense || 'N/A'}
              </span>
            </p>
            <p>
              <strong>Company State License:</strong>{' '}
              <span className="font-semibold">
                {agentCompanyStateLicense || 'N/A'}
              </span>
            </p>
            <p>
              <strong>Company Address:</strong>{' '}
              <span className="font-semibold">
                {agentCompanyAddress || 'N/A'}
              </span>
            </p>
            <p>
              <strong>Agent Mailing Address:</strong>{' '}
              <span className="font-semibold">
                {agentAddress?.street &&
                agentAddress?.city &&
                agentAddress?.state &&
                agentAddress?.zip
                  ? `${agentAddress.street}, ${agentAddress.city}, ${agentAddress.state} ${agentAddress.zip}`
                  : 'N/A'}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Representation;
